import { useStyletron } from "baseui";
import { HeadingXLarge, ParagraphLarge } from "baseui/typography";
import React from "react";
import type { DocsInterfaceProps } from "../../../../src/chrome/DocsInterface";
import { DocsInterface } from "../../../../src/chrome/DocsInterface";
import { SplashCard, SplashCardGrid, SplashContentContainer, colors } from "../../../../src/components/SplashPage";

const ShopifyTutorialsLandingPage = (props: DocsInterfaceProps) => {
  const [css, $theme] = useStyletron();

  return (
    <DocsInterface {...props} showLeftSideNav={true}>
      <SplashContentContainer $style={{ maxWidth: "980px" }}>
        <HeadingXLarge>Shopify tutorials</HeadingXLarge>
        <ParagraphLarge
          $style={{
            paddingTop: $theme.sizing.scale800,
            paddingBottom: $theme.sizing.scale800,
          }}
        >
          Learn how to build Shopify apps using the built-in Shopify plugin, which handles webhook subscriptions, data sync, authentication,
          AppBridge set up, session token management (and more!) out of the box.
        </ParagraphLarge>
        <SplashCardGrid $maxColumns={2} className={css({ marginTop: $theme.sizing.scale1200 })}>
          <SplashCard
            title="Automated product tagger"
            color={colors.white}
            body="Build an embedded Shopify app that automatically tags products in a store based on description keywords."
            href="/guides/tutorials/automated-product-tagger"
            copy="Start building →"
          />
          <SplashCard
            title="Pre-purchase checkout UI extension"
            color={colors.white}
            body="Learn how to use Gadget and metafields to build Shopify checkout UI extensions."
            href="/guides/tutorials/checkout-ui-extension"
            copy="Start building →"
          />
          <SplashCard
            title="Forward data to an existing service"
            color={colors.white}
            body="Use Gadget's background actions to reliably send Shopify data to an existing service."
            href="/guides/tutorials/middleware"
            copy="Start building →"
          />
          <SplashCard
            title="AI product recommendation chatbot"
            color={colors.white}
            body="Use OpenAI to build a storefront chatbot that recommends products to shoppers."
            href="/guides/tutorials/ai-product-recommender"
            copy="Start building →"
          />
          <SplashCard
            title="Product recommendation quiz"
            color={colors.white}
            body="Learn how to call a Gadget API from the Shopify storefront, using a product quiz as an example."
            href="/guides/tutorials/product-recommendation-quiz-app"
            copy="Start building →"
          />
        </SplashCardGrid>
      </SplashContentContainer>
    </DocsInterface>
  );
};

export default ShopifyTutorialsLandingPage;
